var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sortPrice',{on:{"sortType":_vm.sortType}}),_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":"没有更多了"},on:{"load":_vm.getList},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('productionList',{attrs:{"productlist":_vm.datas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }